module.exports = __webpack_public_path__ + "img/608d4c205998c4e9a56375348b68035c.jpg";